import React, { useState, useEffect } from "react";
import { Divider } from "semantic-ui-react";
import {
  Paper,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Button,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import api from "../../api";
import "./Agreement.scss";
import ReactSelect from "react-select";
import {
  CustomerTypeEnum,
  PaymentMethodTypes,
  ResultEnum,
  StatusEnum,
} from "../../enums/enums";
import { DocumentTypes } from "../../enums/enums";
import utils from "../../utils/utils";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/Info";
import { Dimmer, Loader } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CustomTextField = ({
  Name,
  Label,
  Control,
  Type,
  InputProps,
  DefaultValue,
  Required,
  Helper,
  Blur,
  HasError,
  OnInput,
}) => (
  <FormControl fullWidth={true}>
    <Controller
      as={TextField}
      variant="outlined"
      size="small"
      type={Type ?? "text"}
      name={Name}
      label={Label}
      control={Control}
      defaultValue={DefaultValue}
      inputProps={InputProps}
      InputLabelProps={{
        shrink: true,
      }}
      onInput={OnInput}
      helperText={Helper ?? ""}
      required={Required ?? true}
      onBlur={Blur ?? null}
      error={HasError ?? false}
    />
  </FormControl>
);

export default function AgreementCreate({
  setDataToast,
  externalAgreementId,
  onClose,
}) {
  let navigate = useNavigate();
  const [checkBillingData, setCheckBillingData] = useState(true);
  const [documentTypeCustomerSelected, setDocumentTypeCustomerSelected] =
    useState();
  const [documentTypeBillingSelected, setDocumentTypeBillingSelected] =
    useState();
  const [isCreditCard, setIsCreditCard] = useState(false);
  const [hasSalesChannel, setHasSalesChannel] = useState(true);
  const [hasCategoryData, setHasCategoryData] = useState(true);
  const { register, setValue, control, handleSubmit } = useForm({
    mode: "onSubmit",
  });
  const [formData, setFormData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [errorData, setErrorData] = useState({
    paymentNumber: undefined,
  });
  const [data, setData] = useState({
    paymentNumber: undefined,
  });
  const [status, setStatus] = useState();

  const [customerData, setCustomerData] = useState({
    customerName: "",
    customerLastName: "",
    customerDate: "",
    customerBusinessName: "",
    customerIsCompany: false,
    customerDocumentNumber: undefined,
    customerPhone: undefined,
    customerAltPhone: undefined,
    customerEmail: undefined,
    customerDepartment: undefined,
    customerDepartmentNumber: undefined,
    customerPayment: "",
    customerAddress: "",
    customerAddressNumber: "",
  });

  const [billingData, setBillingData] = useState({
    billingName: "",
    billingLastName: "",
    billingBusinessName: "",
    billingDate: "",
    billingIsCompany: false,
    billingDocumentNumber: undefined,
    billingPhone: undefined,
    billingAltPhone: undefined,
  });

  const [paymentValid, setPaymentValid] = useState(false);
  const [stateData, setStateData] = useState();
  const [productData, setProductData] = useState();
  const [paymentMethodData, setPaymentMethodData] = useState();
  const [paymentData, setPaymentData] = useState();
  const [cityData, setCityData] = useState();
  const [stateBillingData, setStateBillingData] = useState();
  const [salesChannelData, setSalesChannelData] = useState();
  const [categoryData, setCategoryData] = useState();
  // Lists
  const [statesList, setStatesList] = useState();
  const [citiesList, setCitiesList] = useState({
    customerState: [],
    billingState: [],
  });
  const [productsList, setProductsList] = useState();
  const [paymentMethodsList, setPaymentMethodsList] = useState();
  const [documentTypesList, setDocumentTypesList] = useState();
  const [salesChannelList, setSalesChannelList] = useState();
  const [categoryList, setCategoryList] = useState();
  const [errorValidateCuitCustomer, setErrorValidateCuitCustomer] =
    useState(false);
  const [errorValidateCuitBilling, setErrorValidateCuitBilling] =
    useState(false);
  const [isCash, setIsCash] = useState(false);

  const { decoded } = useSelector((state) => state.authReducer);

  const selectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (provided) => ({ ...provided, zIndex: "9999 !important" }),
    option: (styles, { data }) => {
      return {
        ...styles,
        color: data["disabled"] ? "red" : "black",
      };
    },
  };
  const selectStyleWithError = {
    ...selectStyles,
    control: (base) => ({
      ...base,
      border: "1px solid red",
    }),
  };

  function validationMessage(message) {
    setIsLoading(false);
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  }

  function save(values) {
    setIsLoading(true);
    if (validate(values)) {
      let billing = undefined;

      if (!checkBillingData) {
        billing = {
          tipoDocumentoId: parseInt(documentTypeBillingSelected),
          numeroDocumento: parseInt(billingData.billingDocumentNumber),
          apellido: billingData.billingIsCompany
            ? null
            : billingData.billingLastName,
          nombre: billingData.billingIsCompany ? null : billingData.billingName,
          razonSocial: billingData.billingIsCompany
            ? billingData.billingBusinessName
            : null,
          esEmpresa: billingData.billingIsCompany
            ? CustomerTypeEnum.Business
            : CustomerTypeEnum.FinalCustomer,
          fechaNacimiento: billingData.billingIsCompany
            ? null
            : values.billingDate,
          localidadId: parseInt(values.billingCity.value),
          direccion: values.billingAddress,
          numeroDireccion: parseInt(values.billingAddressNumber),
          telefonoMovil: parseInt(billingData.billingPhone),
          telefonoAlternativo: billingData.billingAltPhone
            ? parseInt(values.billingAltPhone)
            : undefined,
          email: values.billingEmail,
          departamento: values.billingDepartment
            ? values.billingDepartment
            : undefined,
          departamentoPiso: values.billingDepartmentNumber
            ? parseInt(values.billingDepartmentNumber)
            : undefined,
        };
      }

      let agreement = {
        cliente: {
          tipoDocumentoId: parseInt(documentTypeCustomerSelected),
          numeroDocumento: parseInt(customerData.customerDocumentNumber),
          apellido: customerData.customerIsCompany
            ? null
            : customerData.customerLastName,
          nombre: customerData.customerIsCompany
            ? null
            : customerData.customerName,
          razonSocial: customerData.customerIsCompany
            ? customerData.customerBusinessName
            : null,
          esEmpresa: customerData.customerIsCompany
            ? CustomerTypeEnum.Business
            : CustomerTypeEnum.FinalCustomer,
          fechaNacimiento: customerData.customerIsCompany
            ? null
            : values.customerDate,
          localidadId: parseInt(values.customerCity.value),
          direccion: values.customerAddress,
          numeroDireccion: parseInt(values.customerAddressNumber),
          telefonoMovil: parseInt(customerData.customerPhone),
          telefonoAlternativo: customerData.customerAltPhone
            ? parseInt(values.customerAltPhone)
            : undefined,
          email: values.customerEmail,
          departamento: values.customerDepartment
            ? values.customerDepartment
            : undefined,
          departamentoPiso: values.customerDepartmentNumber
            ? parseInt(values.customerDepartmentNumber)
            : undefined,
        },
        factura: billing,
        canalDeVentaId: salesChannelData
          ? salesChannelData.salesChannel
          : undefined,
        categoriaId: categoryData ? categoryData.categoryId : undefined,
        metodoDePago: {
          medioPagoId: parseInt(formData.paymentType),
          numeroTarjeta: isCreditCard ? data.paymentNumber : undefined,
          cbu: !isCreditCard ? data.paymentNumber : undefined,
        },
      };

      if (externalAgreementId != undefined) {
        setIsLoading(true);
        api
          .postReprocessAgreement(
            values.product,
            externalAgreementId,
            agreement
          )
          .then((res) => {
            setIsLoading(false);
            let data = res.data;
            if (data.result) {
              setDataToast({
                active: true,
                message:
                  data.message + " Contrato N°: " + data.contratoId + ".",
                type: "success",
              });

              onClose();
            } else {
              setDataToast({
                active: true,
                message: data.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            if (Array.isArray(err.response.data.errores)) {
              err.response.data.errores.map((m) => {
                validationMessage(m);
              });
            } else {
              validationMessage("Ocurrió un error.");
            }
          });
      } else {
        api
          .postAgreement(values.product, agreement)
          .then((res) => {
            setIsLoading(false);
            let data = res.data;
            if (data.result) {
              setDataToast({
                active: true,
                message:
                  data.message + " Contrato N°: " + data.contratoId + ".",
                type: "success",
              });

              navigate("/contrato");
            } else {
              setDataToast({
                active: true,
                message: data.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            if (Array.isArray(err.response.data.errores)) {
              err.response.data.errores.map((m) => {
                validationMessage(m);
              });
            } else {
              validationMessage("Ocurrió un error.");
            }
          });
      }
    }
  }

  function getActualDate() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  function validate(values) {
    let actualDate = getActualDate();

    let results = {
      customerDocumentNumber: false,
      billingDocumentNumber: false,
    };
    if (parseInt(documentTypeCustomerSelected) === DocumentTypes.CUIT) {
      results.customerDocumentNumber = validateDocumentNumber(
        customerData.customerDocumentNumber
      );

      if (!results.customerDocumentNumber)
        validationMessage("CUIT de los datos del cliente incorrecto.");
    } else results.customerDocumentNumber = true;

    if (parseInt(documentTypeBillingSelected) === DocumentTypes.CUIT) {
      results.billingDocumentNumber = validateDocumentNumber(
        billingData.billingDocumentNumber
      );

      if (!results.billingDocumentNumber)
        validationMessage("CUIT de los datos de facturación incorrecto.");
    } else results.billingDocumentNumber = true;
    if (
      values.customerCity === "" ||
      values.customerCity === null ||
      values.customerCity === undefined
    ) {
      validationMessage("Debe ingresar una localidad.");
      return false;
    }
    if (!checkBillingData && !parseInt(values.billingCity?.value)) {
      validationMessage("Debe ingresar una localidad de facturación.");
      return false;
    }

    if (
      !customerData.customerIsCompany &&
      new Date(values.customerDate).getTime() >= new Date(actualDate).getTime()
    ) {
      validationMessage("Debe ingresar una fecha de nacimiento válida.");
      return false;
    }

    if (
      !billingData.billingIsCompany &&
      new Date(values.billingDate).getTime() >= new Date(actualDate).getTime()
    ) {
      validationMessage("Debe ingresar una fecha de nacimiento válida.");
      return false;
    }

    if (results.customerDocumentNumber && results.billingDocumentNumber) {
      return true;
    } else {
      return false;
    }
  }

  function validateDocumentNumber(value) {
    let result = false;
    if (value.length === 11) {
      var aCUIT = value.split("");
      var x = 0;

      var vec = [];
      vec[0] = parseInt(value[0]) * 5;
      vec[1] = parseInt(value[1]) * 4;
      vec[2] = parseInt(value[2]) * 3;
      vec[3] = parseInt(value[3]) * 2;
      vec[4] = parseInt(value[4]) * 7;
      vec[5] = parseInt(value[5]) * 6;
      vec[6] = parseInt(value[6]) * 5;
      vec[7] = parseInt(value[7]) * 4;
      vec[8] = parseInt(value[8]) * 3;
      vec[9] = parseInt(value[9]) * 2;

      for (var i = 0; i <= 9; i++) {
        x += vec[i];
      }

      var dv = (11 - (x % 11)) % 11;
      if (dv === parseInt(aCUIT[10])) result = true;
    }
    return result;
  }

  function validation(e) {
    let data = e[0].target;
    let length = data.value.toString().length;

    switch (data.name) {
      default:
      case "paymentCBU":
      case "paymentNumber":
        validationPaymentNumber(length);
        break;
    }
  }

  //Validar el largo del numero de pago, ya sea CBU o Tarjeta de Crédito
  function validationPaymentNumber(length) {
    let response = false;
    if (!isCash) {
      if (isCreditCard) {
        if (length <= 18 && length >= 13) {
          setErrorData({ paymentNumber: false });
          response = true;
        } else {
          setErrorData({ paymentNumber: true });
        }
      } else {
        if (length === 22) {
          setErrorData({ paymentNumber: false });
          response = true;
        } else {
          setErrorData({ paymentNumber: true });
        }
      }
    }
    return response;
  }

  function changePaymentMethod(event) {
    setPaymentMethodData(event[1].props);
    setFormData({
      ...formData,
      [event[0].target.name]: [event[0].target.value],
    });
    setIsCreditCard(
      event[1].props.paymenttype !== PaymentMethodTypes.CBU.Id ? true : false
    );

    if (event[1].props.paymenttype === PaymentMethodTypes.Cash.Id) {
      setValue("paymentNumber", "");
      setData({ ...data, paymentNumber: undefined });
      setPaymentValid(true);
      setIsCash(true);
    } else {
      setPaymentValid(false);
      setIsCash(false);
    }
  }

  function changeCity(event) {
    setStateData(event[1].props);
    if (event[0].target.name === "customerState") {
      setValue("customerCity", "");
    }

    if (event[0].target.name === "billingState") {
      setValue("billingCity", "");
    }

    setIsLoading(true);
    api
      .getCity(event[0].target.value)
      .then((res) => {
        let list = [];
        res.data.forEach((city) => {
          list.push({ key: city.id, value: city.id, label: city.nombre });
        });

        setCitiesList({ ...citiesList, [event[0].target.name]: list });
        setIsLoading(false);
      })
      .catch((err) => validationMessage("Error al obtener las localidades."));
  }

  function changeCityBilling(event) {
    setStateBillingData(event[1].props);
    if (event[0].target.name === "billingState") {
      setValue("billingCity", "");
    }

    setIsLoading(true);
    api
      .getCity(event[0].target.value)
      .then((res) => {
        let list = [];
        res.data.forEach((city) => {
          list.push({ key: city.id, value: city.id, label: city.nombre });
        });

        setCitiesList({ ...citiesList, [event[0].target.name]: list });
        setIsLoading(false);
      })
      .catch((err) => validationMessage("Error al obtener las localidades."));
  }

  function maxLengthCheck(object) {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  }

  function validateCUIT(value) {
    let isError = false;
    let cuitNumber = value.target.value;
    if (
      cuitNumber.length === 11 &&
      (documentTypeCustomerSelected === DocumentTypes.CUIT ||
        documentTypeBillingSelected === DocumentTypes.CUIT)
    ) {
      var aCUIT = cuitNumber.split("");
      var x = 0;

      var vec = [];
      vec[0] = parseInt(cuitNumber[0]) * 5;
      vec[1] = parseInt(cuitNumber[1]) * 4;
      vec[2] = parseInt(cuitNumber[2]) * 3;
      vec[3] = parseInt(cuitNumber[3]) * 2;
      vec[4] = parseInt(cuitNumber[4]) * 7;
      vec[5] = parseInt(cuitNumber[5]) * 6;
      vec[6] = parseInt(cuitNumber[6]) * 5;
      vec[7] = parseInt(cuitNumber[7]) * 4;
      vec[8] = parseInt(cuitNumber[8]) * 3;
      vec[9] = parseInt(cuitNumber[9]) * 2;

      for (var i = 0; i <= 9; i++) {
        x += vec[i];
      }

      var dv = (11 - (x % 11)) % 11;
      if (dv === parseInt(aCUIT[10])) {
        isError = false;
      } else {
        isError = true;
      }
    } else {
      if (
        documentTypeCustomerSelected === DocumentTypes.CUIT ||
        documentTypeBillingSelected === DocumentTypes.CUIT
      ) {
        isError = true;
      } else {
        isError = false;
      }
    }

    if (value.target.name === "customerDocumentNumber") {
      setErrorValidateCuitCustomer(isError);
      setCustomerData({
        ...customerData,
        customerDocumentNumber: cuitNumber.replace(/[^0-9]/g, ""),
      });
    }
    if (value.target.name === "billingDocumentNumber")
      setErrorValidateCuitBilling(isError);

    return isError;
  }

  function shortError(message) {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  }

  function changeSalesChannel(e) {
    const salesChannel = e[0].target.value;
    setSalesChannelData({ salesChannel });
  }
  function changeCategory(e) {
    const categoryId = e[0].target.value;
    setCategoryData({ categoryId });
  }
  function externalAgreementModal(e) {
    setIsLoading(true);

    let companyId = decoded.primarygroupsid;

    api
      .getExternalAgreementById(e)
      .then((res) => {
        setStatus(res.data.status);
        const productId = res.data.productId;
        const documentType = res.data.cliente.tipoDocumentoId;
        const paymentMethod = res.data.metodoDePago.medioPagoId;
        const state = res.data.cliente.provinciaId;
        const city = res.data.cliente.localidadId;
        const salesChannel = res.data.canalDeVentaExternoId;
        const categoryId = res.data.productoCategoriaId;
        res.data.cliente.telefonoMovil =
          res.data.cliente.telefonoMovil?.replace(/[^0-9]/g, "");
        setSalesChannelData({ salesChannel });
        if (salesChannel === undefined || salesChannel === 0) {
          setHasSalesChannel(false);
        }
        setCategoryData({ categoryId });
        if (
          productId === undefined ||
          productId === 0 ||
          categoryId === undefined ||
          categoryId === 0
        ) {
          setHasCategoryData(false);
        }
        setCustomerData({
          ...customerData,
          customerName: res.data.cliente.nombre?.trim() ?? "",
          customerLastName: res.data.cliente.apellido?.trim() ?? "",
          customerDocumentNumber: res.data.cliente.numeroDocumento ?? "",
          customerPhone: res.data.cliente.telefonoMovil ?? "",
          customerAltPhone: res.data.cliente.telefonoAlternativo ?? "",
          customerEmail: res.data.cliente.email?.trim() ?? "",
          customerAddress: res.data.cliente.direccion?.trim() ?? "",
          customerAddressNumber: res.data.cliente.numeroDireccion ?? "",
          customerDate: res.data.cliente.fechaNacimiento?.split("T")[0] ?? "",
        });
        let response = false;
        let length = "";
        if (res.data.metodoDePago.numeroTarjeta != null) {
          setData({
            paymentNumber: res.data.metodoDePago.numeroTarjeta ?? "",
          });
          setPaymentData(res.data.metodoDePago.numeroTarjeta ?? "");
          length = res.data.metodoDePago.numeroTarjeta.length;
          if (length <= 18 && length >= 13) {
            setErrorData({ paymentNumber: false });
            response = true;
          } else {
            setErrorData({ paymentNumber: true });
          }
          setPaymentValid(response);
        } else if (res.data.metodoDePago.cbu != null) {
          setData({
            paymentNumber: res.data.metodoDePago.cbu ?? "",
          });
          setPaymentData(res.data.metodoDePago.cbu ?? "");
          length = res.data.metodoDePago.cbu.length;
          if (length === 22) {
            setErrorData({ paymentNumber: false });
            response = true;
          } else {
            setErrorData({ paymentNumber: true });
          }
          setPaymentValid(response);
        }

        Promise.all([
          api.getProductList().then((res1) => {
            res1.data = utils.refactorDataInList(res1.data, productId);
            let data = utils.setDataProductInList(res1.data);
            if (productId !== null && productId != 0) {
              setProductData(data[0]);
              api
                .getPricesByProductId(productId)
                .then((res) => {
                  let currentDate = new Date();
                  let uniqueCategories = res.data.reduce((acc, item) => {
                    if (
                      new Date(item.fechaPrecio) <= currentDate &&
                      !acc[item.idCategoria]
                    ) {
                      acc[item.idCategoria] = {
                        key: item.idCategoria,
                        value: item.idCategoria,
                        text: item.nombreCategoria,
                        type: item.categoria.nombreCategoriaExterna,
                      };
                    }
                    return acc;
                  }, {});

                  let list = Object.values(uniqueCategories);
                  setCategoryList(list);
                })
                .catch((err) => {
                  shortError("Ocurrió un error al obtener las categorías.");
                  setIsLoading(false);
                });
            }
            setProductsList(data);
          }),
          api.getDocumentTypes().then((res2) => {
            res2.data = utils.refactorDataInList(res2.data, documentType);
            let data = utils.setDataInList(res2.data);
            if (documentType !== null && documentType != 0) {
              setDocumentTypeCustomerSelected(data[0].value);
              setDocumentTypeBillingSelected(data[0].value);
            }
            setDocumentTypesList(data);
          }),
          api.getPaymentMethods().then((res3) => {
            res3.data = utils.refactorDataInList(res3.data, paymentMethod);
            let data = utils.setDataInList(res3.data);
            if (paymentMethod !== null && paymentMethod != 0) {
              setPaymentMethodData(data[0]);
              //Validación payment Method
              setFormData({
                ...formData,
                paymentType: data[0].value,
              });
              setIsCreditCard(
                data[0].type !== PaymentMethodTypes.CBU.Id ? true : false
              );

              if (data[0].type === PaymentMethodTypes.Cash.Id) {
                setValue("paymentNumber", "");
                setData({ ...data, paymentNumber: undefined });
                setPaymentValid(true);
                setIsCash(true);
              } else {
                setPaymentValid(false);
                setIsCash(false);
              }
            }
            setPaymentMethodsList(data);
          }),
          api.getStates().then((res4) => {
            res4.data = utils.refactorDataInList(res4.data, state);
            let data = utils.setDataInList(res4.data);
            if (state !== null && state != 0) {
              setStateData(data[0]);
              api.getCity(state).then((res5) => {
                res5.data = utils.refactorDataInList(res5.data, city);
                let list = [];
                res5.data.forEach((city) => {
                  list.push({
                    key: city.id,
                    value: city.id,
                    label: city.nombre,
                  });
                });
                setCitiesList({ ...citiesList, ["customerState"]: list });
                if (city !== null) {
                  setCityData(list[0]);
                  setStateBillingData(list[0]);
                }
              });
            }
            setStatesList(data);
          }),
          api.getSalesChannelByCompany(1, 10, companyId).then((res6) => {
            let list = [];
            res6.data.salesChannelCompanies.forEach((item) => {
              if (item.canalDeVentaExterno.nombre != null) {
                list.push({
                  id: item.id,
                  nombre: item.canalDeVentaExterno.nombre,
                  type: item.nombreCanalDeVenta,
                });
              }
            });
            setSalesChannelList(utils.setDataInList(list));
          }),
        ]).then(() => setIsLoading(false));
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      });
  }

  function getCategoryByProducts(id) {
    api
      .getPricesByProductId(id)
      .then((res) => {
        let currentDate = new Date();
        let uniqueCategories = res.data.reduce((acc, item) => {
          if (
            new Date(item.fechaPrecio) <= currentDate &&
            !acc[item.idCategoria]
          ) {
            acc[item.idCategoria] = {
              key: item.idCategoria,
              value: item.idCategoria,
              text: item.nombreCategoria,
              type: item.categoria.nombreCategoriaExterna,
            };
          }
          return acc;
        }, {});

        let list = Object.values(uniqueCategories);
        setCategoryList(list);
      })
      .catch((err) => {
        shortError("Ocurrió un error al obtener las categorías.");
        setIsLoading(false);
      });
  }

  function changeTypeDocument(e) {
    if (e[0].target.name === "customerDocumentType") {
      setDocumentTypeCustomerSelected(e[0].target.value);
      if (status !== ResultEnum.Fail) {
        setErrorValidateCuitCustomer(false);
        setCustomerData({
          ...customerData,
          customerDocumentNumber: "",
          customerIsCompany: false,
          customerBusinessName: "",
          customerName: "",
          customerLastName: "",
          customerDate: "",
        });
        setValue("customerDate", "");
      }
    }

    if (e[0].target.name === "billingDocumentType") {
      setDocumentTypeBillingSelected(e[0].target.value);
      if (status !== ResultEnum.Fail) {
        setErrorValidateCuitBilling(false);
        setBillingData({
          ...billingData,
          billingDocumentNumber: "",
          billingIsCompany: false,
          billingBusinessName: "",
          billingName: "",
          billingLastName: "",
          billingDate: "",
        });
        setValue("billingDate", "");
      }
    }
  }

  function corporativeBillingPaymethMethod(e) {
    setIsLoading(true);
    Promise.all([
      setProductData(e[0].target),

      api.getProduct(e[0].target.value, StatusEnum.Active.Id).then((res) => {
        //Si tiene un medio de pago corporativo asignado lo seleciona automaticamente
        if (res.data.medioPagoId !== null) {
          api.getPaymentMethods().then((res2) => {
            res2.data = utils.refactorDataInList(
              res2.data,
              res.data.medioPagoId
            );
            let data = utils.setDataInList(res2.data);
            setPaymentMethodData(data[0]);
            setFormData({
              ...formData,
              paymentType: [data[0].value],
            });
            setIsCreditCard(
              data[0].type !== PaymentMethodTypes.CBU.Id ? true : false
            );
            if (data[0].type === PaymentMethodTypes.Cash.Id) {
              setValue("paymentNumber", "");
              setData({ ...data, paymentNumber: undefined });
              setPaymentValid(true);
              setIsCash(true);
            } else {
              setPaymentValid(false);
              setIsCash(false);
            }
          });
        }
        if (externalAgreementId) {
          setCategoryData(undefined);
          getCategoryByProducts(e[0].target.value);
        }
      }),
    ]).then(() => setIsLoading(false));
  }
  useEffect(() => {
    setIsLoading(true);

    if (externalAgreementId != undefined) {
      externalAgreementModal(externalAgreementId);
    } else {
      Promise.all([
        api.getProductList().then((res) => {
          setProductsList(utils.setDataProductInList(res.data));
        }),
        api.getDocumentTypes().then((res) => {
          setDocumentTypesList(utils.setDataInList(res.data));
        }),
        api.getPaymentMethods().then((res) => {
          setPaymentMethodsList(utils.setDataInList(res.data));
        }),
        api.getStates().then((res) => {
          setStatesList(utils.setDataInList(res.data));
        }),
      ]).then(() => setIsLoading(false));
    }
  }, []);

  return (
    <Paper elevation={3}>
      <form className="c-form" onSubmit={handleSubmit(save)}>
        <Grid container spacing={3}>
          <Grid item md={12}>
            <h1>CONTRATO</h1>
          </Grid>
          <Grid item md={12}>
            <h2>Producto</h2>
            <Divider />
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <FormControl variant="outlined" fullWidth={true} size="small">
                  <InputLabel>Producto</InputLabel>
                  <Controller
                    as={Select}
                    key={"product-" + productData?.value ?? ""}
                    defaultValue={productData?.value ?? ""}
                    control={control}
                    name="product"
                    label="Producto"
                    required={true}
                    ref={register({ required: true })}
                    onChange={(event) => corporativeBillingPaymethMethod(event)}
                    error={
                      externalAgreementId && productData?.value === undefined
                        ? true
                        : false
                    }>
                    {productsList &&
                      productsList.map((item) => (
                        <MenuItem
                          key={item.key}
                          value={item.value}
                          disabled={
                            item.gridId && item.mailConfiguration ? false : true
                          }>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Controller>
                </FormControl>
              </Grid>
              {(!hasCategoryData || externalAgreementId) && (
                <Grid item md={4} xs={12}>
                  <FormControl variant="outlined" fullWidth={true} size="small">
                    <InputLabel>Categoría</InputLabel>
                    <Controller
                      as={Select}
                      control={control}
                      name="category"
                      label="Categoría"
                      required={!hasCategoryData || externalAgreementId}
                      ref={register({ required: true })}
                      onChange={(event) => changeCategory(event)}
                      error={true}>
                      {categoryList &&
                        categoryList.map((item) => (
                          <MenuItem key={item.key} value={item.value}>
                            {item.text}
                          </MenuItem>
                        ))}
                    </Controller>
                  </FormControl>
                </Grid>
              )}
            </Grid>

            <h2>Datos del Cliente</h2>
            <Divider />
            <Grid container spacing={2}>
              <Grid item md={2} xs={5}>
                <FormControl variant="outlined" fullWidth={true} size="small">
                  <InputLabel>Tipo de documento</InputLabel>
                  <Controller
                    as={Select}
                    control={control}
                    key={"documentType-" + documentTypeCustomerSelected ?? ""}
                    name="customerDocumentType"
                    label="Tipo de documento"
                    required
                    defaultValue={documentTypeCustomerSelected ?? ""}
                    ref={register({ required: true })}
                    onChange={(event) => changeTypeDocument(event)}
                    error={
                      externalAgreementId &&
                      documentTypeCustomerSelected === undefined
                        ? true
                        : false
                    }>
                    {documentTypesList &&
                      documentTypesList.map((item) => (
                        <MenuItem key={item.key} value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Controller>
                </FormControl>
              </Grid>
              <Grid item md={3} xs={7}>
                <TextField
                  value={customerData?.customerDocumentNumber ?? ""}
                  name="customerDocumentNumber"
                  label="Número de documento"
                  size="small"
                  control={control}
                  variant="outlined"
                  fullWidth
                  onChange={(event) =>
                    setCustomerData({
                      ...customerData,
                      customerDocumentNumber: event.target.value.replace(
                        /[^0-9]/g,
                        ""
                      ),
                    })
                  }
                  required={true}
                  onBlur={(event) => validateCUIT(event)}
                  error={Boolean(
                    errorValidateCuitCustomer ||
                      (externalAgreementId &&
                        customerData?.customerDocumentNumber === "")
                  )}
                  helperText={
                    errorValidateCuitCustomer === true
                      ? "Ingrese un CUIT válido."
                      : ""
                  }
                />
              </Grid>
              <Grid item md={7}>
                <FormControlLabel
                  control={
                    <Checkbox
                      className="c-checkbox-primary"
                      checked={customerData.customerIsCompany}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setCustomerData((prev) => ({
                            ...prev,
                            customerName: "",
                            customerLastName: "",
                            customerDate: "",
                            customerIsCompany: true,
                          }));
                        } else {
                          setCustomerData((prev) => ({
                            ...prev,
                            customerBusinessName: "",
                            customerIsCompany: false,
                          }));
                        }
                      }}
                    />
                  }
                  label="Es Empresa"
                  style={{
                    visibility:
                      documentTypeCustomerSelected === DocumentTypes.CUIT &&
                      status !== ResultEnum.Fail
                        ? "visible"
                        : "hidden",
                  }}
                />
              </Grid>
              {customerData.customerIsCompany ? (
                <Grid item md={12} xs={6}>
                  <TextField
                    value={customerData?.customerBusinessName ?? ""}
                    name="customerBusinessName"
                    label="Razón social"
                    size="small"
                    control={control}
                    variant="outlined"
                    fullWidth
                    onChange={(event) =>
                      setCustomerData({
                        ...customerData,
                        customerBusinessName: event.target.value.replace(
                          /[^A-Za-zÁÉÍÓÚáéíóúñÑ ]/g,
                          ""
                        ),
                      })
                    }
                    required={customerData.customerIsCompany}
                  />
                </Grid>
              ) : (
                <>
                  <Grid item md={4} xs={6}>
                    <TextField
                      value={customerData?.customerName ?? ""}
                      name="customerName"
                      label="Nombres"
                      size="small"
                      control={control}
                      variant="outlined"
                      fullWidth
                      error={
                        externalAgreementId && customerData?.customerName === ""
                          ? true
                          : false
                      }
                      onChange={(event) =>
                        setCustomerData({
                          ...customerData,
                          customerName: event.target.value.replace(
                            /[^A-Za-zÁÉÍÓÚáéíóúñÑ ]/g,
                            ""
                          ),
                        })
                      }
                      required={!customerData.customerIsCompany}
                    />
                  </Grid>
                  <Grid item md={4} xs={6}>
                    <TextField
                      value={customerData?.customerLastName ?? ""}
                      name="customerLastName"
                      label="Apellido"
                      size="small"
                      control={control}
                      variant="outlined"
                      fullWidth
                      error={
                        externalAgreementId &&
                        customerData?.customerLastName === ""
                          ? true
                          : false
                      }
                      onChange={(event) =>
                        setCustomerData({
                          ...customerData,
                          customerLastName: event.target.value.replace(
                            /[^A-Za-zÁÉÍÓÚáéíóúñÑ ]/g,
                            ""
                          ),
                        })
                      }
                      required={!customerData.customerIsCompany}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <CustomTextField
                      Name="customerDate"
                      Label="Fecha de nacimiento"
                      Control={control}
                      Type="date"
                      key={
                        "clientBirthDate-" + customerData?.customerDate ?? ""
                      }
                      DefaultValue={customerData?.customerDate ?? "2017-05-24"}
                      HasError={Boolean(
                        externalAgreementId && customerData?.customerDate === ""
                      )}
                      Required={!customerData.customerIsCompany}
                    />
                  </Grid>
                </>
              )}
              <Grid item md={6} xs={12}>
                <CustomTextField
                  key={"clientEmail-" + customerData?.customerEmail ?? ""}
                  DefaultValue={customerData?.customerEmail ?? ""}
                  Name="customerEmail"
                  Label="E-mail"
                  Control={control}
                  Type="email"
                  HasError={Boolean(
                    externalAgreementId && customerData?.customerEmail === ""
                  )}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField
                  value={customerData?.customerPhone ?? ""}
                  name="customerPhone"
                  label="Número de teléfono"
                  size="small"
                  control={control}
                  variant="outlined"
                  fullWidth
                  onChange={(event) =>
                    setCustomerData({
                      ...customerData,
                      customerPhone: event.target.value.replace(/[^0-9]/g, ""),
                    })
                  }
                  required={true}
                  inputProps={{ min: 0, maxLength: 18 }}
                  onInput={maxLengthCheck}
                  error={Boolean(
                    externalAgreementId && customerData?.customerPhone === ""
                  )}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField
                  value={customerData?.customerAltPhone ?? ""}
                  name="customerAltPhone"
                  label="Número de teléfono alternativo"
                  size="small"
                  control={control}
                  variant="outlined"
                  fullWidth
                  onChange={(event) =>
                    setCustomerData({
                      ...customerData,
                      customerAltPhone: event.target.value.replace(
                        /[^0-9]/g,
                        ""
                      ),
                    })
                  }
                  inputProps={{ min: 0, maxLength: 18 }}
                  onInput={maxLengthCheck}
                  required={false}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <FormControl variant="outlined" fullWidth={true} size="small">
                  <InputLabel>Provincia</InputLabel>
                  <Controller
                    as={Select}
                    control={control}
                    name="customerState"
                    label="Provincia"
                    required={true}
                    key={"state-" + stateData?.value ?? ""}
                    defaultValue={stateData?.value ?? ""}
                    onChange={changeCity}
                    error={Boolean(
                      externalAgreementId && stateData?.value === undefined
                    )}>
                    {statesList &&
                      statesList.map((item) => (
                        <MenuItem key={item.key} value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Controller>
                </FormControl>
              </Grid>
              <Grid item md={5} xs={12}>
                <FormControl variant="outlined" fullWidth={true} size="small">
                  <Controller
                    as={ReactSelect}
                    control={control}
                    className="c-react-select"
                    placeholder="Buscar localidades..."
                    name="customerCity"
                    options={citiesList["customerState"]}
                    isClearable={true}
                    required={true}
                    ref={register({ required: true })}
                    key={"city-" + cityData ?? ""}
                    defaultValue={cityData ?? ""}
                    styles={
                      externalAgreementId && !cityData
                        ? selectStyleWithError
                        : selectStyles
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item md={6} xs={8}>
                <CustomTextField
                  Name="customerAddress"
                  Label="Dirección"
                  key={"clientAdress-" + customerData?.customerAddress ?? ""}
                  DefaultValue={customerData?.customerAddress ?? ""}
                  Control={control}
                  HasError={
                    externalAgreementId && customerData?.customerAddress === ""
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid item md={2} xs={4}>
                <CustomTextField
                  Name="customerAddressNumber"
                  Label="Número"
                  key={
                    "clientAdressNum-" + customerData?.customerAddressNumber ??
                    ""
                  }
                  DefaultValue={customerData?.customerAddressNumber ?? ""}
                  Control={control}
                  Type="number"
                  InputProps={{ min: 0, maxLength: 6 }}
                  OnInput={maxLengthCheck}
                />
              </Grid>
              <Grid item md={2} xs={8}>
                <CustomTextField
                  Name="customerDepartment"
                  Label="Departamento"
                  key={
                    "clientDepertment-" + customerData?.customerDepartment ?? ""
                  }
                  DefaultValue={customerData?.customerDepartment ?? ""}
                  Control={control}
                  Type="number"
                  InputProps={{ min: 0, maxLength: 5 }}
                  OnInput={maxLengthCheck}
                  Required={false}
                />
              </Grid>
              <Grid item md={2} xs={4}>
                <CustomTextField
                  Name="customerDepartmentNumber"
                  Label="Piso"
                  key={
                    "clientDepertmentNum-" +
                      customerData?.customerDepartmentNumber ?? ""
                  }
                  DefaultValue={customerData?.customerDepartmentNumber ?? ""}
                  Control={control}
                  Type="number"
                  InputProps={{ min: 0, maxLength: 6 }}
                  OnInput={maxLengthCheck}
                  Required={false}
                />
              </Grid>
            </Grid>
            <Grid>
              <FormControlLabel
                control={
                  <Checkbox
                    className="c-checkbox-primary"
                    checked={checkBillingData}
                    onChange={() => setCheckBillingData(!checkBillingData)}
                  />
                }
                label="Usar datos del cliente para datos de facturación"
              />
            </Grid>
            {!checkBillingData && (
              <Grid>
                <h2 className="c-mb-0">Datos de Facturación</h2>
                <Divider />
                <Grid container spacing={2}>
                  <Grid item md={2} xs={5}>
                    <FormControl
                      variant="outlined"
                      fullWidth={true}
                      size="small">
                      <InputLabel>Tipo de documento</InputLabel>
                      <Controller
                        as={Select}
                        control={control}
                        name="billingDocumentType"
                        label="Tipo de documento"
                        required
                        ref={register({ required: true })}
                        onChange={(event) => changeTypeDocument(event)}>
                        {documentTypesList &&
                          documentTypesList.map((item) => (
                            <MenuItem key={item.key} value={item.value}>
                              {item.text}
                            </MenuItem>
                          ))}
                      </Controller>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={7}>
                    <TextField
                      value={billingData.billingDocumentNumber}
                      name="billingDocumentNumber"
                      label="Número de documento"
                      size="small"
                      control={control}
                      variant="outlined"
                      fullWidth
                      onChange={(event) =>
                        setBillingData({
                          ...billingData,
                          billingDocumentNumber: event.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ),
                        })
                      }
                      required={true}
                      onBlur={(event) => validateCUIT(event)}
                      error={errorValidateCuitBilling}
                      helperText={
                        errorValidateCuitBilling === true
                          ? "Ingrese un CUIT válido."
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item md={7}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className="c-checkbox-primary"
                          checked={billingData.billingIsCompany}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setBillingData((prev) => ({
                                ...prev,
                                billingName: "",
                                billingLastName: "",
                                billingDate: "",
                                billingIsCompany: true,
                              }));
                            } else {
                              setBillingData((prev) => ({
                                ...prev,
                                billingBusinessName: "",
                                billingIsCompany: false,
                              }));
                            }
                          }}
                        />
                      }
                      label="Es Empresa"
                      style={{
                        visibility:
                          documentTypeBillingSelected === DocumentTypes.CUIT &&
                          status !== ResultEnum.Fail
                            ? "visible"
                            : "hidden",
                      }}
                    />
                  </Grid>
                  {billingData.billingIsCompany ? (
                    <Grid item md={12} xs={6}>
                      <TextField
                        value={billingData?.billingBusinessName ?? ""}
                        name="billingBusinessName"
                        label="Razón social"
                        size="small"
                        control={control}
                        variant="outlined"
                        fullWidth
                        onChange={(event) =>
                          setBillingData({
                            ...billingData,
                            billingBusinessName: event.target.value.replace(
                              /[^A-Za-zÁÉÍÓÚáéíóúñÑ ]/g,
                              ""
                            ),
                          })
                        }
                        required={billingData.billingIsCompany}
                      />
                    </Grid>
                  ) : (
                    <>
                      <Grid item md={4} xs={4}>
                        <TextField
                          value={billingData.billingName}
                          name="billingName"
                          label="Nombres"
                          size="small"
                          control={control}
                          variant="outlined"
                          fullWidth
                          onChange={(event) =>
                            setBillingData({
                              ...billingData,
                              billingName: event.target.value.replace(
                                /[^A-Za-zÁÉÍÓÚáéíóúñÑ ]/g,
                                ""
                              ),
                            })
                          }
                          required={!billingData.billingIsCompany}
                        />
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <TextField
                          value={billingData.billingLastName}
                          name="billingLastName"
                          label="Apellido"
                          size="small"
                          control={control}
                          variant="outlined"
                          fullWidth
                          onChange={(event) =>
                            setBillingData({
                              ...billingData,
                              billingLastName: event.target.value.replace(
                                /[^A-Za-zÁÉÍÓÚáéíóúñÑ ]/g,
                                ""
                              ),
                            })
                          }
                          required={!billingData.billingIsCompany}
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <CustomTextField
                          Name="billingDate"
                          Label="Fecha de nacimiento"
                          Control={control}
                          Type="date"
                          key={
                            "billingBirthDate-" + billingData?.billingDate ?? ""
                          }
                          DefaultValue={
                            billingData?.billingDate ?? "2017-05-24"
                          }
                          Required={!billingData.billingIsCompany}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      Name="billingEmail"
                      Label="E-mail"
                      Control={control}
                      Type="email"
                      required
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      value={billingData.billingPhone}
                      name="billingPhone"
                      label="Número de teléfono"
                      size="small"
                      control={control}
                      variant="outlined"
                      inputProps={{ min: 0, maxLength: 18 }}
                      fullWidth
                      onChange={(event) =>
                        setBillingData({
                          ...billingData,
                          billingPhone: event.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ),
                        })
                      }
                      required={true}
                      onInput={maxLengthCheck}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      value={billingData.billingAltPhone}
                      name="billingAltPhone"
                      label="Número de teléfono alternativo"
                      size="small"
                      control={control}
                      variant="outlined"
                      fullWidth
                      onChange={(event) =>
                        setBillingData({
                          ...billingData,
                          billingAltPhone: event.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ),
                        })
                      }
                      inputProps={{ min: 0, maxLength: 18 }}
                      onInput={maxLengthCheck}
                      required={false}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl
                      variant="outlined"
                      fullWidth={true}
                      size="small">
                      <InputLabel>Provincia</InputLabel>
                      <Controller
                        as={Select}
                        control={control}
                        name="billingState"
                        label="Provincia"
                        required={true}
                        onChange={changeCityBilling}
                        key={"state-" + stateBillingData?.value ?? ""}
                        defaultValue={stateBillingData?.value ?? ""}>
                        {statesList &&
                          statesList.map((item) => (
                            <MenuItem key={item.key} value={item.value}>
                              {item.text}
                            </MenuItem>
                          ))}
                      </Controller>
                    </FormControl>
                  </Grid>
                  <Grid item md={5} xs={12}>
                    <FormControl
                      variant="outlined"
                      fullWidth={true}
                      size="small">
                      <Controller
                        as={ReactSelect}
                        control={control}
                        className="c-react-select"
                        placeholder="Buscar localidades..."
                        name="billingCity"
                        options={citiesList["billingState"]}
                        isClearable={true}
                        required={true}
                        ref={register({ required: true })}
                        defaultValue={cityData ?? ""}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={8}>
                    <CustomTextField
                      Name="billingAddress"
                      Label="Dirección"
                      required
                      Control={control}
                    />
                  </Grid>
                  <Grid item md={2} xs={4}>
                    <CustomTextField
                      Name="billingAddressNumber"
                      Label="Número"
                      Control={control}
                      required
                      Type="number"
                      InputProps={{ min: 0, maxLength: 6 }}
                      OnInput={maxLengthCheck}
                    />
                  </Grid>
                  <Grid item md={2} xs={8}>
                    <CustomTextField
                      Name="billingDepartment"
                      Label="Departamento"
                      Control={control}
                      Type="number"
                      InputProps={{ min: 0, maxLength: 5 }}
                      OnInput={maxLengthCheck}
                      Required={false}
                    />
                  </Grid>
                  <Grid item md={2} xs={4}>
                    <CustomTextField
                      Name="billingDepartmentNumber"
                      Label="Piso"
                      Control={control}
                      Type="number"
                      InputProps={{ min: 0, maxLength: 6 }}
                      OnInput={maxLengthCheck}
                      Required={false}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}

            <h2>Datos para el pago</h2>
            <Divider />
            <Grid container spacing={2}>
              <Tooltip
                title={
                  "En caso que el producto tenga un medio de pago asignado se seleccionara ese medio de pago."
                }
                placement="top"
                className="t-tip">
                <InfoIcon />
              </Tooltip>
              <Grid item md={3} xs={12}>
                <FormControl variant="outlined" fullWidth={true} size="small">
                  <InputLabel>Medio de pago</InputLabel>
                  <Controller
                    as={Select}
                    control={control}
                    name="paymentType"
                    label="Medio de pago"
                    required={true}
                    key={"paymentMethod-" + paymentMethodData?.value ?? ""}
                    defaultValue={paymentMethodData?.value ?? ""}
                    error={Boolean(
                      externalAgreementId &&
                        paymentMethodData?.value === undefined
                    )}
                    onChange={(e) => {
                      changePaymentMethod(e);
                      let methodIsCash =
                        e[1].props.paymenttype === PaymentMethodTypes.Cash.Id;
                      if (data && data.paymentNumber && !methodIsCash) {
                        if (!validationPaymentNumber(data.paymentNumber)) {
                          setPaymentValid(false);
                        }
                      }
                    }}>
                    {paymentMethodsList &&
                      paymentMethodsList.map((item) => (
                        <MenuItem
                          key={item.key}
                          paymenttype={item.type}
                          value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Controller>
                </FormControl>
              </Grid>
              {!isCash && (
                <Grid item md={4} xs={12}>
                  <FormControl fullWidth={true}>
                    <Controller
                      as={TextField}
                      variant="outlined"
                      size="small"
                      name="paymentNumber"
                      key={"paymentMethodNum-" + paymentData ?? ""}
                      defaultValue={paymentData ?? ""}
                      label={
                        isCreditCard ? "Número de la tarjeta" : "Número del CBU"
                      }
                      onChange={(e) => {
                        validation(e);
                        e[0].target.value = e[0].target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        setData({ ...data, paymentNumber: e[0].target.value });
                        let length = e[0].target.value.length;
                        setPaymentValid(validationPaymentNumber(length));
                      }}
                      inputProps={{
                        autocomplete: "off",
                        maxLength: isCreditCard ? 18 : 22,
                      }}
                      onInput={maxLengthCheck}
                      error={
                        errorData.paymentNumber !== undefined
                          ? errorData.paymentNumber
                          : false
                      }
                      InputLabelProps={{ shrink: true }}
                      control={control}
                      required={!isCash}
                      ref={register({ required: true })}
                    />
                  </FormControl>
                </Grid>
              )}
              {!hasSalesChannel && (
                <Grid item md={4} xs={12}>
                  <FormControl variant="outlined" fullWidth={true} size="small">
                    <InputLabel>Canal de Venta</InputLabel>
                    <Controller
                      as={Select}
                      control={control}
                      name="salesChannel"
                      label="Canal de Venta"
                      required
                      ref={register({ required: true })}
                      onChange={(event) => changeSalesChannel(event)}
                      error={true}>
                      {salesChannelList &&
                        salesChannelList.map((item) => (
                          <MenuItem key={item.key} value={item.value}>
                            {item.text}
                          </MenuItem>
                        ))}
                    </Controller>
                  </FormControl>
                </Grid>
              )}
            </Grid>

            {isLoading && (
              <Dimmer className="c-loader" active>
                <Loader content="Cargando..." />
              </Dimmer>
            )}

            <Grid container spacing={2} className="c-mt-15">
              <Grid className="c-text-right" item md={12} xs={12}>
                {externalAgreementId != undefined && (
                  <Button variant="contained" onClick={() => onClose()}>
                    Cancelar
                  </Button>
                )}
                {externalAgreementId === undefined && (
                  <Button variant="contained" onClick={() => navigate(-1)}>
                    Cancelar
                  </Button>
                )}
                <Button
                  variant="contained"
                  type="submit"
                  className="c-ml-5 c-btn-success">
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
}
